import moment from "moment/moment";
import DateFormatEnum from "../../enums/DateFormatEnum";
import { AutomationTypeEnum, RunIntervalEnum } from "~/pages/automation/enums";

const AutomationItemMixin = {
  props: {
    automation: {
      type: Object,
      required: true,
    },
  },
  computed: {
    runInterval() {
      return this.automationConfiguration?.run_interval;
    },
    nextSendDate() {
      if (this.runInterval === RunIntervalEnum.ONCE && this.automationConfiguration.last_ran_at) {
        return moment(this.automationConfiguration.last_ran_at)
          .format(DateFormatEnum.NEW_DISPLAY_DATE);
      }

      switch (this.runInterval) {
        case RunIntervalEnum.NEVER:
          return ", niet deze staat uit.";
        case RunIntervalEnum.ONCE:
          return "nog niet uitgevoerd";
        case RunIntervalEnum.DAILY:
          return moment()
            .add(1, "day")
            .format(DateFormatEnum.NEW_DISPLAY_DATE);
        case RunIntervalEnum.WEEKLY:
          return moment()
            .startOf("isoWeek")
            .add(1, "week")
            .format(DateFormatEnum.NEW_DISPLAY_DATE);
        case RunIntervalEnum.MONTHLY:
          return moment()
            .startOf("month")
            .add(1, "month")
            .format(DateFormatEnum.NEW_DISPLAY_DATE);
        case RunIntervalEnum.QUARTERLY:
          return moment()
            .startOf("month")
            .add(3, "month")
            .format(DateFormatEnum.NEW_DISPLAY_DATE);
        case RunIntervalEnum.YEARLY:
          return moment()
            .startOf("month")
            .add(1, "year")
            .format(DateFormatEnum.NEW_DISPLAY_DATE);
        default:
          return "onbekend";
      }
    },

    createsSignal() {
      return this.automationConfiguration.create_signal || false;
    },
    createsTask() {
      return this.automationConfiguration.create_task || false;
    },
    sendsEmail() {
      return this.automationConfiguration.send_email || false;
    },
    isRecurring() {
      return this.automationConfiguration.is_recurring || false;
    },
    isCampaign() {
      return this.automation.type === AutomationTypeEnum.CAMPAIGN;
    },
    isSelection() {
      return this.automation.type === AutomationTypeEnum.SELECTION;
    },
    isDataEnrichment() {
      return this.automation.type === AutomationTypeEnum.DATA_ENRICHMENT;
    },
    needsVerification() {
      return this.automation.needs_verification;
    },
    fontColorStyle() {
      return this.isActive ? "color-white" : "color-primary";
    },
    badgeStyle() {
      return this.isActive ? "color-white border-color-white" : "color-primary border-color-primary";
    },
    infoColorClass() {
      return this.isActive ? "bg-color-white-transparent color-white" : "bg-color-primary-transparent color-black";
    },
    iconClass() {
      return this.isActive ? "fill-white signalIcon icon-size-xl" : "fill-primary signalIcon icon-size-xl";
    },
    price() {
      return "0 credits";
    },
    intervalDescription() {
      // eslint-disable-next-line default-case
      switch (this.runInterval) {
        case RunIntervalEnum.NEVER:
          return "nooit";
        case RunIntervalEnum.DAILY:
          return "dagelijks";
        case RunIntervalEnum.WEEKLY:
          return "wekelijks";
        case RunIntervalEnum.MONTHLY:
          return "maandelijks";
        case RunIntervalEnum.QUARTERLY:
          return "ieder kwartaal";
        case RunIntervalEnum.YEARLY:
          return "jaarlijks";
      }

      return "onbekend";
    },
    runIntervalDescription() {
      if (this.runInterval === RunIntervalEnum.NEVER) {
        return RunIntervalEnum.NEVER;
      }
      if (this.runInterval === RunIntervalEnum.ONCE) {
        if (this.automation.last_ran_at === null) {
          return "not_yet_executed";
        }
        return RunIntervalEnum.ONCE;
      }
      return RunIntervalEnum.RECURRING;
    },
  },
};

export default AutomationItemMixin;
